import connectUs from './connectUs/reducer';
import profile from './profile/reducer';
import partner from './partner/reducer';
import transactions from './transactions/reducer';
import ticket from './ticket/reducer';
import status from './status/reducer';
import pool from './pool/reducer';
import auth from './auth/reducer';
import news from './news/reducer';
import documents from './documents/reducer';

export default {
  connectUs,
  profile,
  partner,
  transactions,
  ticket,
  status,
  pool,
  auth,
  news,
  documents,
};
